/*
<button type="button" class="js-display-drawer" data-target="#drawer_IDUNIQUE">
open drawer
</button>

<div id="drawer_IDUNIQUE" class="drawer js-drawer">
<div class="drawer__overlay js-drawer-close"></div>	
<div class="drawer__container inner js-drawer-content">
<button type="button" class="drawer__close js-drawer-close">
<svg class="icon icon-close drawer__close-svg" aria-hidden="true"><use xlink:href="#icon-close" /></svg>
</button>
<div class="drawer__content">
<div class="drawer__title">titre drawer</div>
</div>
</div><!-- drawer__container -->
</div><!-- drawer -->
*/
var drawer = {
  ui: {},

  init: function () {
    this.bindUI();
    this.bindEvents();
    if (window.location.hash) {
      if ($(window.location.hash).hasClass("js-drawer")) {
        this.openDrawer($(window.location.hash));
      }
    }
    const urlParams = new URLSearchParams(document.location.search);
    const openDrawerID = urlParams.get("openDrawer");
    if (openDrawerID) {
      this.openDrawer($("#" + openDrawerID));
    }
  },

  bindUI: function () {
    this.ui.displayDrawer_selector = ".js-display-drawer";
    this.ui.drawerClose_selector = ".js-drawer-close";
  },

  bindEvents: function () {
    $("body").on(
      "click",
      this.ui.displayDrawer_selector,
      this.onClickOpen.bind(this)
    );
    $("body").on(
      "click",
      this.ui.drawerClose_selector,
      this.onClickClose.bind(this)
    );
  },

  drawerContentClick: function (e) {
    e.stopPropagation();
  },
  onClickOpen: function (e) {
    console.log("drawerOpen");
    e.stopImmediatePropagation();
    e.preventDefault();
    let self = this;
    let $this = $(e.target);
    if (!$this.hasClass("js-display-drawer")) {
      $this = $this.closest(".js-display-drawer");
    }
    let $target = $($this.attr("data-target"));
    this.openDrawer($target);
  },
  openDrawer($target) {
    $target.fadeIn(200).addClass("open");
    $("html, body").addClass("disable-scroll");

    var $loadOnOpen = $target.find(".js-drawer-load-on-open");
    if ($loadOnOpen.length > 0) {
      this.loadOnOpen($loadOnOpen);
    }
  },

  loadOnOpen: function ($loadOnOpen) {
    var ajaxTargetUrl = $loadOnOpen.attr("data-ajaxUrl");
    $loadOnOpen.find(".js-drawer-load-on-open-loader").addClass("active");

    if (window.currentajax) {
      // si requete en cours, on l'annule et la remplace par la nouvelle
      window.currentajax.abort();
    }
    // post or get
    window.currentajax = $.get(ajaxTargetUrl, function (response) {})
      .done(function (response) {
        if (response.form) {
          $loadOnOpen
            .find(".js-drawer-load-on-open-content")
            .html("")
            .append($(response.form));
          $loadOnOpen.trigger("ajax-complete");

          // TODO : check what is drawerProductPreview
          // if ($loadOnOpen.find(".js-drawerProductPreview")) {
          // 	drawerProductPreview.init();
          // }
          $loadOnOpen
            .find(".js-addScrolledBottomClassOnBottomScroll")
            .on("scroll", checkScrolledBottom);
        } else {
          $loadOnOpen.find(".js-drawer-load-on-open-content").html("error");
        }
      })
      .fail(function (response) {
        $loadOnOpen.find(".js-drawer-load-on-open-content").html("error");
      })
      .always(function (response) {
        $loadOnOpen
          .find(".js-drawer-load-on-open-loader")
          .removeClass("active");
      });
  },

  onClickClose: function (e) {
    let self = this;
    let $this = $(e.target);
    let $targetDrawer;
    e.stopPropagation();

    if ($this.hasClass("js-drawer")) {
      $targetDrawer = $this;
    } else {
      $targetDrawer = $this.closest(".js-drawer");
    }
    this.closeDrawer($targetDrawer);
  },
  closeDrawer($targetDrawer) {
    $targetDrawer.fadeOut(200).removeClass("open");
    $("html, body").removeClass("disable-scroll");

    var $removeOnClose = $targetDrawer.find(
      ".js-drawer-remove-on-close-content"
    );
    if ($removeOnClose.length > 0) {
      this.removeOnClose($removeOnClose);
    }
  },

  removeOnClose: function ($removeOnClose) {
    $removeOnClose.html("");
  },
};

module.exports = drawer;
